(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3],{

/***/ 4803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Base_Slots; }
});

// EXTERNAL MODULE: ./node_modules/@xprog/prensa/index.js
var prensa = __webpack_require__(2003);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(6486);
// EXTERNAL MODULE: ./providers/Article/index.tsx
var Article = __webpack_require__(6521);
// EXTERNAL MODULE: ./providers/Pages/index.tsx
var Pages = __webpack_require__(9859);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/crypto-js/md5.js
var md5 = __webpack_require__(8214);
var md5_default = /*#__PURE__*/__webpack_require__.n(md5);
// EXTERNAL MODULE: ./components/Base/Base.index.tsx + 112 modules
var Base_index = __webpack_require__(9849);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Base/Base.Slots.styled.tsx



var SlotMainColumn = function SlotMainColumn(props) {
  if (props.variant === 'oneColumn') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
      className: "SlotContainer",
      css: {
        '.MainContent': {
          align: ['column', 'center', 'top'],
          width: '100%'
        },
        width: '100%',
        '@lg': {
          align: ['row', 'center', 'top'] // mt: '$12'

        }
      },
      children: props.children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
    className: "SlotContainer",
    css: {
      mt: '$4',
      width: '100%',
      '.MainContent': {
        align: ['column', 'center', 'top'],
        width: '100%'
      },
      '.SideContent': {
        align: ['column', 'center', 'top'],
        width: '100%'
      },
      '@lg': {
        align: ['row', 'center', 'top'],
        alignItems: 'stretch',
        mt: '$4',
        '.MainContent': {
          maxWidth: 'calc(1280px - 324px)',
          width: 'calc(calc(100% - 300px) - $8)'
        },
        '.SideContent': {
          ml: '$6',
          width: '300px'
        }
      }
    },
    children: props.children
  });
};

/* harmony default export */ var Base_Slots_styled = (SlotMainColumn);
// EXTERNAL MODULE: ./components/Ads/Ads.Slot.tsx + 4 modules
var Ads_Slot = __webpack_require__(2547);
;// CONCATENATED MODULE: ./components/Base/Base.Slots.tsx













var MainContentBlock = function MainContentBlock(_ref) {
  var contentBlock = _ref.contentBlock,
      contentSide = _ref.contentSide;
  var slots = contentBlock.concat(contentSide);

  if (slots.length == 0) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  var variant = contentSide && contentSide.length > 0 ? 'twoColumns' : 'oneColumn';
  var megaDataSlot = {
    contentBlock: contentBlock,
    contentSide: contentSide
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot/* default */.Z, {
      type: "mega",
      componentReference: "top",
      data: megaDataSlot
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Base_Slots_styled, {
      variant: variant,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        className: "MainContent",
        children: (0,lodash.map)(contentBlock, function (data, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(Base_index.ComponentSwitch, {
            data: data
          }, key);
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(prensa/* Block */.gO, {
        className: "SideContent",
        children: (0,lodash.map)(contentSide, function (data, key) {
          return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot/* default */.Z, {
              type: "side",
              componentReference: "top",
              data: data
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(Base_index.ComponentSwitch, {
              data: data
            }, key), /*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot/* default */.Z, {
              type: "side",
              componentReference: "bottom",
              data: data
            })]
          });
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Ads_Slot/* default */.Z, {
      type: "mega",
      componentReference: "bottom",
      data: megaDataSlot
    })]
  });
};

var MemoizedMainContentBlock = /*#__PURE__*/(0,react.memo)(MainContentBlock, function (prevProps, nextProps) {
  // Creating an MD5 hash of the props to prevent a second render of blocks
  // with the same props since changes in the context will create a cascade effect
  // triggering the render of all children's components
  var prevPropsString = JSON.stringify(prevProps, null, 2);
  var nextPropsString = JSON.stringify(nextProps, null, 2);
  var prevPropsMD5Hash = md5_default()(prevPropsString).toString();
  var nextPropsMD5Hash = md5_default()(nextPropsString).toString();
  return prevPropsMD5Hash === nextPropsMD5Hash;
});

var RenderSlots = function RenderSlots() {
  var _useContext = (0,react.useContext)(Pages.PagesContext),
      pageList = _useContext.pageList,
      pageListData = _useContext.pageListData,
      pageLoading = _useContext.pageLoading;

  var _useContext2 = (0,react.useContext)(Article.ArticleContext),
      articles = _useContext2.articles;

  var slotsData = pageListData;
  var slotsList = pageList;

  var getItem = function getItem(value) {
    var items = [];
    (0,lodash.map)((0,lodash.get)(slotsList, value, []), function (item) {
      var policy = {
        id: item.replace('contentid/', 'policy:')
      };
      var found = (0,lodash.find)(slotsData, policy);
      found && items.push(found);
    });
    return items;
  };

  var contentPage;
  var haveArticles = articles && articles.length > 0;

  if (haveArticles) {
    contentPage = [{
      contentBlock: getItem('p2g1slot1list'),
      contentSide: getItem('p2g1slot2list')
    }, {
      contentBlock: getItem('p2g2slot1list'),
      contentSide: getItem('p2g2slot2list')
    }, {
      contentBlock: getItem('p3g1slot1list'),
      contentSide: getItem('p3g1slot2list')
    }, {
      contentBlock: getItem('p3g2slot1list'),
      contentSide: getItem('p3g2slot2list')
    }, {
      contentBlock: getItem('p3g3slot1list'),
      contentSide: getItem('p3g3slot2list')
    }, {
      contentBlock: getItem('p3g4slot1list'),
      contentSide: getItem('p3g4slot2list')
    }, {
      contentBlock: getItem('p2g3slot1list'),
      contentSide: getItem('p2g3slot2list')
    }, {
      contentBlock: getItem('p2g4slot1list'),
      contentSide: getItem('p2g4slot2list')
    }];
  } else {
    contentPage = [];
    contentPage.push({
      contentBlock: getItem('p2g1slot1list'),
      contentSide: getItem('p2g1slot2list')
    });
    contentPage.push({
      contentBlock: getItem('p2g2slot1list'),
      contentSide: getItem('p2g2slot2list')
    });
    contentPage.push({
      contentBlock: getItem('p1g1slot1list'),
      contentSide: getItem('p1g1slot2list')
    });
    contentPage.push({
      contentBlock: getItem('p1g2slot1list'),
      contentSide: getItem('p1g2slot2list')
    });
    contentPage.push({
      contentBlock: getItem('p1g3slot1list'),
      contentSide: getItem('p1g3slot2list')
    });
    contentPage.push({
      contentBlock: getItem('p1g4slot1list'),
      contentSide: getItem('p1g4slot2list')
    });
    contentPage.push({
      contentBlock: getItem('p1g5slot1list'),
      contentSide: getItem('p1g5slot2list')
    });
    contentPage.push({
      contentBlock: getItem('p1g6slot1list'),
      contentSide: getItem('p1g6slot2list')
    });
    contentPage.push({
      contentBlock: getItem('p1g7slot1list'),
      contentSide: getItem('p1g7slot2list')
    });
    contentPage.push({
      contentBlock: getItem('p1g8slot1list'),
      contentSide: getItem('p1g8slot2list')
    });
    contentPage.push({
      contentBlock: getItem('p2g3slot1list'),
      contentSide: getItem('p2g3slot2list')
    });
    contentPage.push({
      contentBlock: getItem('p2g4slot1list'),
      contentSide: getItem('p2g4slot2list')
    });
  }

  if (pageLoading) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: (0,lodash.map)(contentPage, function (_ref2, key) {
      var contentBlock = _ref2.contentBlock,
          contentSide = _ref2.contentSide;
      return /*#__PURE__*/(0,jsx_runtime.jsx)(MemoizedMainContentBlock, {
        contentBlock: contentBlock,
        contentSide: contentSide
      }, key);
    })
  });
};

/* harmony default export */ var Base_Slots = (RenderSlots);

/***/ }),

/***/ 2480:
/***/ (function() {

/* (ignored) */

/***/ })

}]);